import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Row,
  Col,
  Label,
  Button,
  FormGroup,
  Input,
  Form,
  Alert,
} from 'reactstrap';

const LoginForm = ({ credentials, onChange, onLogin, loggingIn, errors }) => {
  return (
    <Container>
      <Row>
        <Col md={3} />
        <Col md={6}>
          <Form>
            {errors.credentials && (
              <Alert color={'danger'}>{errors.credentials}</Alert>
            )}
            <FormGroup>
              <Label for="username">Username</Label>
              <Input
                type="text"
                name="username"
                id="username"
                value={credentials.username}
                onChange={onChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="password">Password</Label>
              <Input
                type="password"
                id="password"
                value={credentials.password}
                onChange={onChange}
              />
            </FormGroup>
            <FormGroup>
              <Button
                color="primary"
                type="submit"
                onClick={onLogin}
                className="mr-2"
                disabled={loggingIn}
              >
                Login
              </Button>
            </FormGroup>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

LoginForm.propTypes = {
  credentials: PropTypes.object,
};

export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/login/LoginForm.js